(() => {
  const root = window.Shopify?.routes?.root || '/';
  let busy = false;

  const applyCart = (cart) => {
    document.querySelectorAll('.at-cart > span').forEach((badge) => {
      badge.textContent = cart.item_count;
    });
    document.querySelectorAll('[data-auric-quick]').forEach((form) => {
      const variantId = form.elements.id.value;
      const quantity = Number(form.elements.quantity.value);
      const inCart = cart.items.filter((item) => String(item.variant_id) === variantId).reduce((sum, item) => sum + item.quantity, 0);
      const max = form.dataset.totalMax === '' ? null : Number(form.dataset.totalMax);
      const available = form.dataset.available === 'true';
      const canAdd = available && (max === null || max - inCart >= quantity);
      form.querySelectorAll('button[type="submit"]').forEach((button) => {
        button.disabled = !canAdd || form.dataset.busy === 'true';
      });
      form.querySelector('[data-auric-quick-status]').textContent = !available ? form.dataset.soldLabel : !canAdd ? form.dataset.cartFullLabel : '';
    });
    document.dispatchEvent(new CustomEvent('auric:cart-updated', { detail: cart }));
  };

  const refreshCart = async () => {
    const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' }, cache: 'no-store' });
    if (!response.ok) throw new Error();
    const cart = await response.json();
    applyCart(cart);
    return cart;
  };

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!form.matches('[data-auric-purchase]') || event.defaultPrevented) return;
    event.preventDefault();
    if (busy || !form.reportValidity()) return;
    const submitter = event.submitter;
    if (submitter?.disabled) return;
    const buyNow = submitter?.hasAttribute('data-auric-buy');
    const drawer = document.querySelector('cart-drawer');
    const feedback = form.querySelector('[data-auric-error]');
    const formData = new FormData(form);
    if (drawer && !buyNow) {
      formData.append('sections', drawer.getSectionsToRender().map((section) => section.id).join(','));
      formData.append('sections_url', window.location.pathname);
      drawer.setActiveElement(submitter);
    }
    const buttons = [...form.querySelectorAll('button[type="submit"]')].map((button) => [button, button.disabled]);
    busy = true;
    form.dataset.busy = 'true';
    form.setAttribute('aria-busy', 'true');
    buttons.forEach(([button]) => { button.disabled = true; });
    feedback.hidden = true;
    let cart;
    try {
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData,
      });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(typeof result.description === 'string' ? result.description : form.dataset.errorLabel);
      if (buyNow) {
        window.location.assign(`${root}checkout`);
        return;
      }
      if (!drawer || !result.sections?.['cart-drawer']) {
        window.location.assign(`${root}cart`);
        return;
      }
      drawer.classList.remove('is-empty');
      drawer.renderContents(result);
      cart = await refreshCart().catch(() => null);
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'auric-purchase', productVariantId: formData.get('id'), cartData: cart || result });
      }
    } catch (error) {
      feedback.textContent = error.message || form.dataset.errorLabel;
      feedback.hidden = false;
      cart = await refreshCart().catch(() => null);
    } finally {
      busy = false;
      form.dataset.busy = 'false';
      form.removeAttribute('aria-busy');
      buttons.forEach(([button, disabled]) => { button.disabled = disabled; });
      if (cart) applyCart(cart);
    }
  });

  document.addEventListener('click', (event) => {
    const link = event.target.closest('.at-cart');
    const drawer = document.querySelector('cart-drawer');
    if (!link || !drawer || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    drawer.open(link);
  });

  window.addEventListener('pageshow', () => { refreshCart().catch(() => {}); });
  window.addEventListener('focus', () => { refreshCart().catch(() => {}); });
  document.addEventListener('DOMContentLoaded', () => {
    const link = document.querySelector('.at-cart');
    if (link && document.querySelector('cart-drawer')) link.setAttribute('aria-haspopup', 'dialog');
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (event.source !== 'auric-purchase') refreshCart().catch(() => {});
      });
    }
  });
})();

